import { scroller } from 'react-scroll'

// scrolls to element on page with name of url hash
export default function scrollToHash({ location: { hash } }) {
  const scrollFunc = () =>
    scroller.scrollTo(hash.substring(1), { smooth: true })
  if (hash) setTimeout(scrollFunc, 500)
}
